<div class="wrapper">
    <section class="container">

        <div class="row features justify-content-center">
            <section class="col-12 col-12-mobile feature">

                <div class="image-wrapper row mt-3">
                    <div class="col-4 col-12-narrower p-0">
                        <div class="image featured"><img id="agileimg" src="/freepics/agile.webp" alt="Agile Softwareentwicklung" width="1024" height="819" loading="lazy" decoding="async" i18n-alt /></div>
                    </div>
                    <div class="col-8 col-12-narrower align-self-center">
                        <header class="major">
                            <h2 i18n>Agile Softwareentwicklung</h2>
                        </header>
                        <p i18n>Agile Softwareentwicklung ist der Kern unserer Arbeitsweise. Mit einem flexiblen, iterativen Ansatz stellen wir sicher, dass Ihre Anforderungen stets im
                            Mittelpunkt stehen. Durch enge Zusammenarbeit mit Ihnen und regelmäßige Feedback-Schleifen passen wir uns schnell an Veränderungen an und liefern
                            kontinuierlich wertvolle Software, die Ihren Bedürfnissen entspricht. Unser agiles Vorgehen fördert Transparenz, Effizienz und eine schnelle
                            Time-to-Market – für maßgeschneiderte Lösungen, die nachhaltig überzeugen.</p>
                    </div>
                </div>

            </section>
        </div>
    </section>
</div>
